import {Component, OnDestroy, OnInit} from '@angular/core';
import {DispatcherService, IdNameString, ResponsiveService, StorageService} from '@core/src/public-api';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {I18nService} from '@services/i18n.service';

@Component({
  selector: 'si-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  isMobile: boolean;
  showLogoForce = true;
  styleClass: string;
  showMenu = false;
  showNotificationBox = false;
  showAppoRequestIcon = false;
  openMenu = false;
  isStorageActive: Observable<boolean>;
  languageValues: IdNameString[];

  constructor(
    private responsiveService: ResponsiveService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dispatcher: DispatcherService,
    private storageService: StorageService,
    private i18nService: I18nService
  ) {
    this.isStorageActive = this.storageService.getStorageActiveObservable();
  }

  ngOnInit(): void {
    this.isMobile = this.responsiveService.isMobile();
    this.languageValues = this.i18nService.getActiveLanguageValues();
    this.onNavigationEnd();
    this.subscriptions.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => this.onNavigationEnd())
    );
    this.dispatcher.register('pasi-nav-click-outside-menu', () => this.closeNavMenu(), 'top-bar');
  }

  onNavigationEnd(): void {
    this.getRouteData();
  }

  getRouteData(): void {
    let routeSnapshot = this.activatedRoute.snapshot;
    while (routeSnapshot.firstChild) {
      routeSnapshot = routeSnapshot.firstChild;
    }

    const routeData = routeSnapshot.data;
    this.showLogoForce = routeData.topBarShowLogoForce;
    this.styleClass = routeData.topBarStyleClass || '';
    this.showMenu = routeData.topBarShowMenu !== false;
    this.showNotificationBox = routeData.topBarShowshowNotificationBox !== false;
    this.showAppoRequestIcon = routeData.topBarShowAppoRequestIcon === true;
  }

  onClickMenu(event: Event): void {
    this.openNavMenu();
  }

  openNavMenu(): void {
    this.openMenu = true;
    this.dispatcher.exec('si-nav-sidebar-toggle');
  }

  closeNavMenu(): void {
    this.openMenu = false;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.dispatcher.unregisterFunction('pasi-nav-click-outside-menu', 'top-bar');
  }
}
